import React, { createContext, useMemo, useReducer } from 'react';
import pollActions from '@/actions/shared/pollActions';
import pollReducer from '@/reducers/shared/pollReducer';

export const PollContext = createContext();

const PollContextProvider = (props) => {
  const [pollState, dispatch] = useReducer(pollReducer, {
    currentPollProgress: false,
    currentPollLoaded: false,
    currentPollError: null,
    pollPostProgress: false,
    pollPostLoaded: false,
    pollPostError: null,
    poll: null,
    answer: null,
  });
  const actions = useMemo(() => pollActions(dispatch), [dispatch]);

  return (
    <PollContext.Provider value={{ pollState, dispatch, actions }}>
      {props.children}
    </PollContext.Provider>
  );
};

export default PollContextProvider;
